export type RequestVersionRef = {
  current: number;
};

export function invalidateListRequest(
  requestVersionRef: RequestVersionRef,
  cancel?: null | (() => void),
) {
  requestVersionRef.current += 1;
  cancel?.();
  return requestVersionRef.current;
}
